import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selecttenantDomainFunctionsListItems} from '../../../../../redux/TenantDomainFunctions/selector';
import { selecttenantDomainFunctionEntitiesListItems, selecttenantDomainFunctionEntitiesQueryItems } from '../../../../../redux/tenant-domain-function-entities/selector';
import { tenantDomainFunctionEntities } from '../../../../../redux/tenant-domain-function-entities/action';
import TenantDomainFunctionEntityComponent from '../components/components/tenant-domain-function-entity.component';
import { tenantDomainFunctions } from '../../../../../redux/TenantDomainFunctions/action';
import PageLoader from '../../../../../components/PageLoader';
import { selectFeaturesListItems } from '../../../../../redux/features/selector';
import { features } from '../../../../../redux/features/action';
import { selectDomainsListItems } from '../../../../../redux/domains/selector';
import { domains } from '../../../../../redux/domains/action';


const TenantDomainFunctionEntity= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selecttenantDomainFunctionEntitiesQueryItems)
 const DomainItems = useSelector(selecttenantDomainFunctionsListItems)
 const tenantDomainEntityItems = useSelector(selecttenantDomainFunctionEntitiesListItems)
 const routeQuery = useSelector(selectFeaturesListItems)
 const [isLoading, setIsLoading] = useState<boolean>(true)
 const domainItems = useSelector(selectDomainsListItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedDomainEntity,
    setSelectedDomainEntity
  ] = useState<any>( {
    FeatureId:0,
    DomainId: 0,
    FunctionId: 0,
    EntityName: '',
    IsParent: false,
    ParentEntityId: 0,
    EntityTypeId: 0,
    EntityLevelId: 0,
    IsActive: false,
    IsTagAllowed: false,
    IsTenantEntityAttributeAllowed: false,
    HasFolder: false,
    Code: ''
  })

  const fetchTenatDomainFunctionById= ()=>{
    dispatch(tenantDomainFunctionEntities.query({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/entities/query`,entity:'tenantDomainFunctionEntities',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedDomainEntity({ ...selectedDomainEntity, [field]: event });
  }

  useEffect(
    () => {
     
      dispatch(features.list({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/features/list`,
        entity: 'features',
        jsonData: {}
    })).then(()=>{
      dispatch(tenantDomainFunctions.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/functions/list`,entity:'tenantDomainFunctions',jsonData:{
      }})).then(()=>{
        dispatch(tenantDomainFunctionEntities.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/entities/list`,entity:'tenantDomainFunctionEntities',jsonData:{
          }}))}).then(()=>{
            dispatch(domains.list({
              url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/domains/list`,
              entity: 'domains',
              jsonData: {}
          }))}).then(()=>{
      if (parmas?.id > 0) {
        fetchTenatDomainFunctionById()
        setIsLoading(false)
      }
      else{
        setIsLoading(false)
      }
    })
  })
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedDomainEntity(queryItems?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    console.log(selectedDomainEntity,'selectedDomainEntity')
    if (parmas?.id > 0) {
      await dispatch(tenantDomainFunctionEntities.resetAction({ actionType: 'update' }))
      await dispatch(tenantDomainFunctionEntities.update({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/entities`,entity:'tenantDomainFunctionEntities',jsonData:{
          
    Records: [
        selectedDomainEntity
    ]
 
}})).then(()=>{
  back()
})

    }else{
      await dispatch(tenantDomainFunctionEntities.resetAction({ actionType: 'create' }))
      await dispatch(tenantDomainFunctionEntities.create({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/entities`,entity:'tenantDomainFunctionEntities',jsonData:{
          
      Records: [
          selectedDomainEntity
      ]
    
  }})).then(()=>{
    back()
  })
    }

  }

  const parentEntity = tenantDomainEntityItems?.result?.items.filter(
    (subDomainData: any) => subDomainData.IsParent === true
  )
const back=()=>{
  navigate('/management/platform-management/entities')
} 
    return (
    <>
      {isLoading ? <PageLoader /> : 
          <TenantDomainFunctionEntityComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedDomainEntity={selectedDomainEntity}
           back={back}
           handleFormSubmit={handleFormSubmit}
           domain={DomainItems?.result?.items}
           parentDomain={routeQuery?.result?.items}
           parentEntity={parentEntity}
           domainDetails={domainItems?.result?.items}
          />  }
          </>
    )
    
    }
   
    export default TenantDomainFunctionEntity;